import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';
import { StatusBag } from '@app/enums';
import { Passenger } from '@app/models';
import { Passenger as PassengerNew } from '@app/models/micro';
import { PassengerService } from '@app/services/micro/passenger.service';
import { classCssTiers } from '@app/utils/constants/redentions';

/**
 * Componente para mostrar el estado de una maleta.
 *
 */
@Component({
    selector: 'am-passenger-cell-carryOn',
    templateUrl: './am-passenger-cell-carryOn.component.html',
    styleUrls: ['./am-passenger-cell-carryOn.component.scss'],
    standalone: false
})
export class AmPassengerCellCarryOnComponent implements OnInit {

  @Input() passenger: Passenger;
  @Input() passengerNew: PassengerNew;

  constructor(
    private _passengerService: PassengerService
  ) { }

  ngOnInit(): void {
  }

  get classTier() {
    return '';
    //return classCssTiers[this.passenger.benefits?.tier] || '';
  }

  get cost() {
    let totalToPay = 0;
    
    // Calcular costo de maletas en bagStack (equipaje documentado) - solo seleccionadas
    this.passengerNew.bagStack?.forEach(bag => {
      if (bag.status === StatusBag.TO_PAY) {
        totalToPay += bag.currency?.total || 0;
      }
    });
    
    // Calcular costo de maletas en bagStackCarryon (carry-on) - solo seleccionadas
    this.passengerNew.bagStackCarryon?.forEach(bag => {
      if (bag.status === StatusBag.TO_PAY) {
        totalToPay += bag.currency?.total || 0;
      }
    });
    
    // Calcular costo de maletas en bagOfferCarryOnStack (checkbox carry-on) - solo seleccionadas
    this.passengerNew.bagOfferCarryOnStack?.forEach(bag => {
      if (bag.status === StatusBag.TO_PAY) {
        totalToPay += bag.currency?.total || bag.currencyPerLeg?.[0]?.currency?.total || 0;
      }
    });
    
    return totalToPay;
  }

  get hasInfant() {
    return this.passengerNew?.hasInfant || false;
  }

  get infant() {
    //return this._passengerService.getInfantByAdult(this.passenger);
    return null;
  }

}
